// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    // production: false,
    // URL_SERVER: "http://localhost/CyberSecurityServer/Api/admin/",
    // URL_IMAGE: "http://localhost/CyberSecurityServer/image.php",


    production: true,
    URL_SERVER: "https://cybersecurity.theskinnerbox.it/rest/Api/",
    URL_IMAGE: "https://cybersecurity.theskinnerbox.it/rest/image.php",

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts